import { DesignActionCollection } from "./DesignActionCollection";
import { DesignerMode } from "../../types";
import { FC } from "react";
import { IContainerActionAttributes } from "../../../base/models";
import { ViewActionCollection } from "./ViewActionCollection";
import { useDesignContext } from "../../../providers";

export const ActionCollection: FC<IContainerActionAttributes> = ({
    action, actions, onDesignChange
}) => {
    const { action: { designerMode } } = useDesignContext()

    switch (designerMode) {
        case DesignerMode.Draft:
            return <DesignActionCollection
                action={action}
                actions={actions}
                onDesignChange={onDesignChange} />
        case DesignerMode.View:
            return <ViewActionCollection
                action={action}
                actions={actions}
                onDesignChange={() => { }} />
    }
}